import {useCallback, useEffect} from 'react';
import {useUiState} from '../../Components/Context/UserInterface/UserInterfaceContext';
import {UserInterfaceActions} from '../../Components/Context/UserInterface/UserInterfaceActionTypes';
import {ThreeDPreviewStatus} from '../../Enums';
import {ModelSubTypes} from '@taopix/taopix-core';

const use3DProjectObserver = (): void => {
  const loader = window.Taopix.Core.get('loader');
  const ui = useUiState();

  const on3DPreviewLoad = useCallback((settings: {modelSubType: ModelSubTypes; data: any}) => {
    if (ModelSubTypes.None !== settings.modelSubType) {
      // The first time we receive this event, the data may not be loaded but we can setup the UI to expect a 3D preview early.
      // The second time we receive this event, the data should be loaded (or errored which will fall into the else block).
      ui.dispatch(
        UserInterfaceActions.set3DPreviewStatus(
          undefined === settings.data ? ThreeDPreviewStatus.Loading : ThreeDPreviewStatus.Loaded
        )
      );
    } else {
      ui.dispatch(UserInterfaceActions.set3DPreviewStatus(ThreeDPreviewStatus.None));
    }
  }, []);

  useEffect(() => {
    loader.on('on3DPreviewLoad', on3DPreviewLoad);

    return () => {
      loader.off('on3DPreviewLoad', on3DPreviewLoad);
    };
  }, [on3DPreviewLoad]);

  return;
};

export default use3DProjectObserver;
